import { render, staticRenderFns } from "./ShowRoom.vue?vue&type=template&id=52f670c3&scoped=true"
import script from "./ShowRoom.vue?vue&type=script&lang=js"
export * from "./ShowRoom.vue?vue&type=script&lang=js"
import style0 from "./ShowRoom.vue?vue&type=style&index=0&id=52f670c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f670c3",
  null
  
)

export default component.exports